<script lang="ts" setup>
import { storeToRefs } from 'pinia';

const breakpoints = {
    320: {
        panelsPerView: 2
    },
    576: {
        panelsPerView: 3
    },
    768: {
        panelsPerView: 4
    },
    1200: {
        panelsPerView: 6
    },
    1400: {
        panelsPerView: 7
    },
    1630: {
        panelsPerView: 9
    }
} as const satisfies Breakpoints;

const isReady = ref(false);

const cartStore = useCartStore();

const { cart } = storeToRefs(cartStore);

defineProps<{
    data?: LiteNft[];
    isLoading?: boolean;
    isError?: boolean;
    title?: string;
}>();

</script>

<template>
  <CardSlider :breakpoints="breakpoints"
              :data="data"
              :title="title"
              :is-loading="isLoading"
              :is-error="isError"
              @on-ready="payload => isReady = payload"
  >
    <template #loader>
      <LoaderSkeleton :height="282"
                      :style="{ 'flex-grow': 1 }"
      />
    </template>
    <template #empty>
      <div class="display-flex justify-center align-items-center height">
        <span class="compact-500-accent">No similar tokens found</span>
      </div>
    </template>
    <template #error>
      <div class="display-flex align-items-center width-full justify-center height">
        <span class="display-500-accent">Oops, something went wrong</span>
      </div>
    </template>
    <template #card="{ item: card, index }">
      <NftCard :key="index"
               :collectionSlug="card.collection.slug"
               :address="card.address"
               :identifier="card.identifier"
               :img="card.displayAnimationURL || card.displayImageURL"
               :is-exist-to-cart="isReady && cart.has(card.uuid)"
               :itemType="card.itemType"
               :network="card.network"
               :price="card.price"
               :title="card.name"
               :ownedCount="card.ownedCount"
               :uuid="card.uuid"
               class="slide"
               sizes="126px xs:157px sm:176px md:155px lg:163px xl:160px xxl:175px"
               :class="{ [`async-loader-nft`]: !isReady, margin: isReady }"
               @handle-cart="cartStore.handleCartItems({
                 name: card.name,
                 uuid: card.uuid,
                 displayImageURL: card.displayImageURL,
                 price: card.price,
                 network: card.network,
                 itemType: card.itemType,
                 ...(isEvmErc1155(card.itemType) ? { maxAmount1155: Number(card.price?.amount) } : {})
               })"
      />
    </template>
  </CardSlider>
</template>

<style lang="scss" scoped>

.margin {
  margin-right: 17px;
}

.height {
  height: 282px;

  @include desktop-1440 {
    height: 293px
  }

  @include tablet-768 {
    height: 350px
  }

  @include mobile-576 {
    height: 322px
  }
}

.async-loader-nft {
  max-width: calc(100% / 9 - 15px);
  margin-right: 17px;

  @include desktop-1440 {
    max-width: calc(100% / 5 - 15px);
  }

  @include tablet-1024 {
    max-width: calc(100% / 4 - 15px);
  }

  @include tablet-768 {
    max-width: calc(100% / 3 - 15px);
  }

  @include mobile-576 {
    max-width: calc(100% / 2 - 15px);
  }
}
</style>
